export default "__VITE_ASSET__Cibr97LT__"